import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    fechaComprobante: moment(new Date()).format('YYYY-MM-DD'),
    fechaEntrega: moment(new Date()).format('YYYY-MM-DD'),
    proveedorId: 0,
    proveedor: null,
    presupuestoInternoId: 0,
    monedaId: 0,
    moneda: null,
    direccionEntrega: '',
    observaciones: '',
    ordenSinCostos: false,
    costoRemitos: false,
    rowVersion: null,

    noRequiereContrato: false,
    tieneContrato: false,
    contratoPagare: false,

    renglones: [],
    formasPago: [],
    importeTotal: 0,

    ordenProveedorDatos: [],
    ordenProveedorRenglonDatos: [],
    ordenProveedorFormaPagoDatos: [],
    ordenProveedorEvaluacionDatos: [],
    ordenProveedorDatosRpt: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, ordenProveedorId) {
        state.id = ordenProveedorId;
        state.fechaComprobante = moment(new Date()).format('YYYY-MM-DD'),
        state.fechaEntrega = moment(new Date()).format('YYYY-MM-DD'),
        state.proveedorId = 0;
        state.proveedor = '';
        state.presupuestoInternoId = 0;
        state.monedaId = 0;
        state.moneda = '';
        state.direccionEntrega = '';
        state.observaciones = '';
        state.ordenSinCostos = false;
        state.costoRemitos = false;
        state.rowVersion = null;

        state.renglones = [];
        state.formasPago = [];
        state.importeTotal = 0;

        state.noRequiereContrato = false;
        state.tieneContrato = false;
        state.contratoPagare = false;
    },
    'SET_ORDEN' (state, ordenProveedor) {
        state.fechaComprobante = moment(ordenProveedor.fechaComprobante).format('YYYY-MM-DD'),
        state.fechaEntrega = moment(ordenProveedor.fechaEntrega).format('YYYY-MM-DD'),
        state.proveedorId = ordenProveedor.proveedorId;
        state.proveedor = ordenProveedor.proveedor.trim();
        state.presupuestoInternoId = ordenProveedor.presupuestoInternoId;
        state.monedaId = ordenProveedor.monedaId;
        state.moneda = ordenProveedor.moneda.trim();
        state.direccionEntrega = ordenProveedor.direccionEntrega.trim();
        state.observaciones = ordenProveedor.observaciones.trim();
        state.ordenSinCostos = (/true/i).test(ordenProveedor.ordenSinCostos);
        state.costoRemitos = (/true/i).test(ordenProveedor.costoRemitos);
        state.rowVersion = ordenProveedor.rowVersion;

        state.renglones = ordenProveedor.renglones;
        state.importeTotal = state.renglones
            .reduce((importeTotal, renglon) => importeTotal + (renglon.precioUnitario ? renglon.cantidad * renglon.importe : renglon.importeTotal) , 0);

        state.formasPago = ordenProveedor.formasPago;
        
        state.noRequiereContrato = ordenProveedor.proveedorNoRequiereContrato;
        state.tieneContrato = ordenProveedor.proveedorTieneContrato;
        state.contratoPagare = ordenProveedor.proveedorContratoPagare;
    },
    'ADD_ORDEN' (state, params) {
        state.id = 0;
        state.fechaComprobante = moment(new Date()).format('YYYY-MM-DD'),
        state.fechaEntrega = moment(new Date()).format('YYYY-MM-DD'),
        state.proveedorId = params.proveedorId;
        state.proveedor = params.proveedor;
        state.presupuestoInternoId = params.presupuestoInternoId;
        state.monedaId = params.monedaId;
        state.moneda = params.moneda;
        state.direccionEntrega = '';
        state.observaciones = ''; 
        state.ordenSinCostos = false;
        state.costoRemitos = (/true/i).test(params.costoRemitos) || false;
        
        state.renglones = [];
        state.formasPago = [];
        state.importeTotal = 0;

        if (params.renglones) {
            if (params.renglones.length) {
                params.renglones.forEach(renglon => {
                    state.renglones.push({
                        ordenTrabajoId: renglon.ordenTrabajoId,
                        ordenSubtrabajoId: renglon.ordenSubtrabajoId,
                        ordenTrabajoInternaId: 0,
                        articuloTipo: renglon.articuloTipo,
                        cantidad: renglon.cantidad,
                        importe: renglon.importe,
                        importeTotal: renglon.importeTotal,
                        precioUnitario: renglon.precioUnitario,
                    })
                });
            }
            state.importeTotal = state.renglones
                .reduce((importeTotal, renglon) => importeTotal + (renglon.precioUnitario ? renglon.cantidad * renglon.importe : renglon.importeTotal) , 0);
        }
    },
    'ADD_ORDEN_TRABAJO_INTERNA' (state, params) {
        state.id = 0;
        state.fechaComprobante = moment(new Date()).format('YYYY-MM-DD'),
        state.fechaEntrega = moment(new Date()).format('YYYY-MM-DD'),
        state.proveedorId = params.proveedorId;
        state.proveedor = params.proveedor;
        state.monedaId = params.monedaId;
        state.moneda = params.moneda;
        state.direccionEntrega = '';
        state.observaciones = ''; 
        state.ordenSinCostos = false;
        state.costoRemitos = false;
        
        state.renglones = [];
        state.formasPago = [];
        state.importeTotal = 0;

        if (params.renglones) {
            if (params.renglones.length) {
                params.renglones.forEach(renglon => {
                    state.renglones.push({
                        ordenTrabajoId: 0,
                        ordenSubtrabajoId: 0,
                        ordenTrabajoInternaId: renglon.ordenTrabajoInternaId,
                        articuloTipo: renglon.articuloTipo,
                        cantidad: renglon.cantidad,
                        importe: renglon.importe,
                        importeTotal: renglon.importeTotal,
                        precioUnitario: renglon.precioUnitario,
                    })
                });
            }
            state.importeTotal = state.renglones
                .reduce((importeTotal, renglon) => importeTotal + (renglon.precioUnitario ? renglon.cantidad * renglon.importe : renglon.importeTotal) , 0);
        }
    },
    'SET_PROVEEDOR'(state, proveedor) {
        state.noRequiereContrato = proveedor.noRequiereContrato;
        state.tieneContrato = proveedor.tieneContrato;
        state.contratoPagare = proveedor.contratoPagare;

        if (proveedor.formaPagoId != 0) {
            let addFormaPago = true;
            if (state.formasPago) {
                if (state.formasPago.length != 0) {
                    addFormaPago = false;
                }
            }
            if (addFormaPago) {
                state.formasPago.push({
                    formaPagoId: proveedor.formaPagoId,
                    formaPago: proveedor.formaPago.nombre.trim(),
                    porcentaje: parseFloat(100),
                    condiciones: '',
                })
            }
        }
    },
    'SET_MONEDA'(state, moneda) {
        if (moneda) {
            state.monedaId = moneda.id? moneda.id : 0;
            state.moneda = moneda.nombre? moneda.nombre.trim() : '';
        } else {
            state.monedaId = 0;
            state.moneda = '';
        }
    },

    'ADD_FORMA_PAGO'(state, formaPago) {
        state.formasPago.push({
            formaPagoId: formaPago.formaPagoId,
            formaPago: formaPago.formaPago.nombre.trim(),
            porcentaje: formaPago.porcentaje,
            condiciones: formaPago.condiciones.trim(),
        })
    },
    'REMOVE_FORMA_PAGO'(state, formaPago) {
        let key = state.formasPago.findIndex(fp => fp == formaPago);
        if (key != -1) {
            state.formasPago.splice(key, 1);
        }
    },
    'SET_ORDEN_ID' (state, ordenProveedor) {
        state.id = ordenProveedor.id;
        state.rowVersion = ordenProveedor.rowVersion;
    },

    'INICIALIZAR_DATOS' (state) {
        state.ordenProveedorDatos = [];
        state.ordenProveedorRenglonDatos = [];
        state.ordenProveedorFormaPagoDatos = [];
        state.ordenProveedorEvaluacionDatos = [];
        state.ordenProveedorDatosRpt = [];
    },
    'SET_ORDEN_DATOS' (state, params) {
        state.ordenProveedorDatos = params.ordenProveedorDatos;
        state.ordenProveedorRenglonDatos = params.ordenProveedorRenglonDatos.map(renglon => ({
            ...renglon,
            moneda: params.ordenProveedorDatosRpt.moneda
        }));
        state.ordenProveedorFormaPagoDatos = params.ordenProveedorFormaPagoDatos;
        state.ordenProveedorEvaluacionDatos = params.ordenProveedorEvaluacionDatos;
        state.ordenProveedorDatosRpt = params.ordenProveedorDatosRpt;
    },
};

const getters = {
    getField,

    ordenProveedor(state) {
        return {
            id: state.id,
            renglones: state.renglones
        }
    },
    ordenProveedorDatosRpt(state) {
        return state.ordenProveedorDatosRpt;
    },
    ordenProveedorRenglones(state) {
        return state.ordenProveedorRenglonDatos.filter(renglon => renglon.ordenTrabajoId != 0);
    },
    ordenProveedorRenglonesInternas(state) {
        return state.ordenProveedorRenglonDatos.filter(renglon => renglon.ordenTrabajoInternaId != 0);
    },
};

const actions = {
    inicializar ( { commit }, ordenProveedorId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', ordenProveedorId);
            
            let getOrden = false;
            if (ordenProveedorId) {
                if (ordenProveedorId != 0) {
                    getOrden = true;
                }
            }
            if (getOrden) {
                apiAxios.get('ordenesproveedores/' + ordenProveedorId + '/abm' ) 
                    .then(res => {
                        commit('SET_ORDEN', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));

            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })            
    },
    addOrden ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('ADD_ORDEN', params);
            
            if (params.proveedorId != 0) {
                /* Recuperamos informacion del proveedor */
                apiAxios.get('proveedores/' + params.proveedorId + '/ordenes') 
                    .then(res => {
                        commit('SET_PROVEEDOR', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })            
    },
    addOrdenTrabajoInterna ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('ADD_ORDEN_TRABAJO_INTERNA', params);
            // console.log(params.proveedorId);
            if (params.proveedorId != 0) {
                /* Recuperamos informacion del proveedor */
                apiAxios.get('proveedores/' + params.proveedorId + '/ordenes') 
                    .then(res => {
                        commit('SET_PROVEEDOR', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })            
    },
    save ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMsj = '';

            let totalRenglones = 0;

            let renglones = [];
            if (state.renglones) {
                state.renglones.forEach(renglon => {
                    let importe = parseFloat(renglon.importe);
                    let importeTotal = parseFloat(renglon.importeTotal);

                    if ((/true/i).test(renglon.precioUnitario)) {
                        importeTotal = helpers.methods.roundToTwo(parseFloat(renglon.cantidad) * importe);
                    } else {
                        if (parseFloat(renglon.cantidad) == 0) {
                            importe = 0;
                        } else {
                            importe = helpers.methods.roundToTwo(importeTotal / parseFloat(renglon.cantidad));
                        }
                    }

                    renglones.push({
                        ordenTrabajoId: renglon.ordenTrabajoId,
                        ordenSubtrabajoId: renglon.ordenSubtrabajoId,
                        ordenTrabajoInternaId: renglon.ordenTrabajoInternaId,
                        cantidad: renglon.cantidad,
                        importe,
                        importeTotal,
                        // importe: renglon.importe,
                        // importeTotal: renglon.importeTotal,
                        precioUnitario: renglon.precioUnitario,
                    })
                });

                totalRenglones = state.renglones
                    .reduce((total, subtrabajo) => total + subtrabajo.importeTotal, 0);
            
            }
            if (totalRenglones == 0 & !(/true/i).test(state.ordenSinCostos) & !(/true/i).test(state.costoRemitos)) {
                save = false;
                errorMsj = 'El total de los renglones incluidos es igual a cero.\nDeberá marcar la opción de calcular el importe a partir de los remitos asociados para poder registrarla.';
            }

            let formasPago = [];
            let porcentajeTotal = 0;
            if (state.formasPago) {
                state.formasPago.forEach(formaPago => {
                    formasPago.push({
                        formaPagoId: formaPago.formaPagoId,
                        porcentaje: formaPago.porcentaje,
                        condiciones: formaPago.condiciones.trim()
                    })
                    porcentajeTotal += formaPago.porcentaje;
                });
            }
            // if (porcentajeTotal != 0 & porcentajeTotal != 100) {
            if (formasPago.length == 0) {
                save = false;
                errorMsj = 'Debe seleccionar la forma de pago correspondiente.';
            } else if (porcentajeTotal != 100) {
                save = false;
                errorMsj = 'El porcentaje total correspondiente a las formas de pago seleccionadas debe ser igual a 100.';
            }
            
            let ordenProveedor= {
                fechaComprobante: moment(state.fechaComprobante).format('YYYY-MM-DD'),
                fechaEntrega: moment(state.fechaEntrega).format('YYYY-MM-DD'),
                proveedorId: parseInt(state.proveedorId),
                presupuestoInternoId: parseInt(state.presupuestoInternoId),
                monedaId: parseInt(state.monedaId),
                direccionEntrega: state.direccionEntrega.trim().toUpperCase(),
                observaciones: state.observaciones.trim(),
                ordenSinCostos: (/true/i).test(state.ordenSinCostos),
                costoRemitos: (/true/i).test(state.costoRemitos),
                renglones: renglones,
                formasPago: formasPago
            };

            let url = 'ordenesproveedores';
            if (state.id != 0) {
                url += "/" + state.id;
                ordenProveedor.rowVersion = state.rowVersion;
            }

            if (save) {
                apiAxios.post(url, ordenProveedor)
                    .then(res => {
                        /* Actualizamos Id y RowVersion */
                        commit('SET_ORDEN_ID', res.data);

                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMsj);
            }
        })
    },
    // setFormaPago ( { commit }, formaPago ) {
    //     commit('SET_FORMA_PAGO', formaPago);
    // },
    addFormaPago ( { commit }, formaPago ) {
        commit('ADD_FORMA_PAGO', formaPago);
    },
    removeFormaPago ( { commit }, formaPago ) {
        commit('REMOVE_FORMA_PAGO', formaPago);
    },

    getDatos ( { commit }, ordenProveedorId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (ordenProveedorId) {
                apiAxios.get('ordenesproveedores/' + ordenProveedorId ) 
                    .then(res => {
                        let montoTotal = helpers.methods.formattedMoneda(res.data.montoTotal, res.data.moneda);
                        let montoCancelado = helpers.methods.formattedMoneda(res.data.importeCancelado, res.data.moneda);

                        let ordenProveedorDatos = [
                            { 'nombre': 'id', 'campo': 'Nro. Orden', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'fechaComprobante', 'campo': 'Fecha Comprobante', 'valor': res.data.fechaComprobante, 'formato': 'fecha' },
                            { 'nombre': 'fechaEntrega', 'campo': 'Fecha de Entrega', 'valor': res.data.fechaEntrega, 'formato': 'fecha' },
                            { 'nombre': 'proveedor', 'campo': 'Proveedor', 'valor': res.data.proveedor, 'formato': '' },
                            // { 'nombre': 'presupuestoInternoId', 'campo': 'Nro. Presupuesto', 'valor': res.data.presupuestoInternoId, 'formato': '' },
                            { 'nombre': 'presupuestoNumero', 'campo': 'Nro. Presupuesto', 'valor': res.data.presupuestoNumero, 'formato': '' },
                            { 'nombre': 'presupuestoInterno', 'campo': 'Presupuesto Interno', 'valor': res.data.presupuestoInterno, 'formato': '' },
                            { 'nombre': 'montoTotal', 'campo': 'Monto Total (Iva no incluido)', 'valor': montoTotal, 'formato': '' },
                        ]

                        // if (res.data.monedaId != 101) {
                        //     ordenProveedorDatos.push({ 'nombre': 'cotizacion', 'campo': `Cotización ${res.data.monedaAbreviacion}`, 'valor': res.data.cotizacion, 'formato': 'moneda' });
                        // }

                        ordenProveedorDatos.push(
                            { 'nombre': 'direccionEntrega', 'campo': 'Direccion de Entrega', 'valor': res.data.direccionEntrega, 'formato': '' },
                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones.trim(), 'formato': '' },
                            // { 'nombre': 'ordenSinCostos', 'campo': 'Emitida s/costos', 'valor': res.data.ordenSinCostos? 'Si' : 'No', 'formato': '' },
                            { 'nombre': 'costoRemitos', 'campo': 'Costo según Remitos', 'valor': res.data.costoRemitos? 'Si' : 'No', 'formato': '' },
                        );

                        if (parseFloat(res.data.importeCancelado) != 0) {
                            ordenProveedorDatos.push(
                                { 'nombre': 'fechaCancelacionSaldo', 'campo': 'Cancelación Saldo', 'valor': res.data.fechaCancelacionSaldo, 'formato': 'fechaHora' },
                                { 'nombre': 'usuarioCancelacionSaldo', 'campo': 'Usuario Cancelación', 'valor': res.data.usuarioCancelacionSaldo.trim(), 'formato': '' },
                                { 'nombre': 'importeCancelado', 'campo': 'Monto Cancelado', 'valor': montoCancelado, 'formato': '' },
                            );
                        }

                        ordenProveedorDatos.push(
                            { 'nombre': 'usuario', 'campo': 'Usuario', 'valor': res.data.usuario, 'formato': '' },
                            { 'nombre': 'fechaBorrado', 'campo': 'Fecha Anulación', 'valor': res.data.fechaBorrado, 'formato': 'fechaHora' },
                            { 'nombre': 'usuarioBorrado', 'campo': 'Anuló', 'valor': res.data.usuarioBorrado, 'formato': '' }
                        );

                        let ordenProveedorEvaluacionDatos = [];
                        if ((/true/i).test(res.data.noEvaluar)) {
                            ordenProveedorEvaluacionDatos.push(
                                { 'nombre': 'evaluacion', 'campo': 'No Evaluar (Proveedor)', 'valor': '', 'formato': '' },
                            )
                        }
                        if ((/true/i).test(res.data.evaluada)) {
                            ordenProveedorEvaluacionDatos.push(
                                { 'nombre': 'fechaEvaluacion', 'campo': 'Fecha Evaluación', 'valor': res.data.fechaNoEvaluacion, 'formato': 'fechaHora' },
                                { 'nombre': 'calificacionEvaluacion', 'campo': 'Calificación', 'valor': res.data.calificacionEvaluacion, 'formato': '' },
                                { 'nombre': 'usuarioEvaluacion', 'campo': 'Usuario', 'valor': res.data.usuarioEvaluacion, 'formato': '' },
                                { 'nombre': 'observacionesEvaluacion', 'campo': 'Observaciones', 'valor': res.data.observacionesEvaluacion, 'formato': '' }
                            )
                        }

                        let params = {
                            ordenProveedorDatos,
                            ordenProveedorRenglonDatos: res.data.renglones,
                            ordenProveedorFormaPagoDatos: res.data.formasPago,
                            ordenProveedorEvaluacionDatos,
                            ordenProveedorDatosRpt: res.data
                        }
                                      
                        commit('SET_ORDEN_DATOS', params);
                        resolve();
                    })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        }, error => {
            reject(error);
        })            
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}